const TabItem = ({ id, onClick, children,  className= '' }) => (
  <div
    className={`tab-panel ${className}`}
    role='tabpanel'
    aria-labelledby={`tab-${id}`}
    id={`panel-${id}`}
    onClick={onClick}
  >
      {children}
  </div>
);

export default TabItem;
